Views.add(new class extends AbstractView {

  constructor() {
    super({
      name: 'about',
      overlay: true
    });
  }

  onActive() {

  }

  mainTitle() {
    return Wording.about_window_title.replace(/%{\$?brand_name}/gi, Utils.capitalize(this.app._brand));
  }

  smallTitle() {
    return Wording.about_window_subtitle.replace(/%{\$?brand_name}/gi, Utils.capitalize(this.app._brand));
  }

  initEventListeners() {

  }

  _htmlBase() {
    let displayImage = true;
    let image = this.app._slaask
                ? "https://uploads.slaask.com/assets/Slaask-is-a-customer-service-app-for-all-Slack-users.svg"
                : "https://cdn.polaria.ai/xeno/02_unification.svg"
    let brand = Utils.capitalize(this.app._brand)

    if (brand == 'Polaria') {
      brand = 'Polaria Tech';
      displayImage = false;
    }
    if (brand == 'Sarbacane') {
      brand = 'Sarbacane Chat';
      displayImage = false;
    }
    return `
      <div class="slaask-widget-homepage-card slaask-widget-card">
        ${displayImage ? `<img src="${image}" style="width:100%;margin-bottom:20px" />` : ''}
        <span class="slaask-widget-homepage-card-title">
          ${Wording.about_window_subtitle.replace(/%{\$?brand_name}/gi, brand)}
        </span>
        <p>${Wording.about_window_desc.replace(/%{\$?brand_name}/gi, brand)}</p>
        <a target="_blank" href="${this.app._whitelabel_link}" class="slaask-widget-homepage-cta" style="background-color: ${this.app._window_color};color: #ffffff">
          ${Wording.about_window_cta.replace(/%{\$?brand_name}/gi, brand)}
          
          <svg style="width: 16px; height: 16px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="external-link-alt"><path fill="currentColor" d="M18,10.82a1,1,0,0,0-1,1V19a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V8A1,1,0,0,1,5,7h7.18a1,1,0,0,0,0-2H5A3,3,0,0,0,2,8V19a3,3,0,0,0,3,3H16a3,3,0,0,0,3-3V11.82A1,1,0,0,0,18,10.82Zm3.92-8.2a1,1,0,0,0-.54-.54A1,1,0,0,0,21,2H15a1,1,0,0,0,0,2h3.59L8.29,14.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,5.41V9a1,1,0,0,0,2,0V3A1,1,0,0,0,21.92,2.62Z"></path></svg>
        </a>
      </div>`
  }
});
